export const suggestions = {
  1: "Hello, I would like to schedule an appointment for a general checkup",
  2: "Hello, I would like to schedule an appointment to have my pet vacinated",
  3: "Hello, I would like to schedule a virtual appointment",
  4: "Thanks!",
  5: "Yes",
};
